import type { VehicleCategoryData, VehicleCategoryDataVehicleCategoryEnum } from '~/api/prebooking'
import * as Sentry from '@sentry/vue'
import { defineStore, storeToRefs } from 'pinia'
import { ExternalControllerApi } from '~/api/prebooking'
import { useLocationStore } from '~/stores/location'
import { useSubscriptionDateTimeStore } from '~/stores/subscription-datetime'

const prebookingApi = new ExternalControllerApi()

export const useSubscriptionVehiclesStore = defineStore('subscription-vehicles', () => {
  const buildSeriesToCategory = reactive<Map<string, VehicleCategoryDataVehicleCategoryEnum>>(new Map())
  const buildSeriesToData = reactive<Map<string, VehicleCategoryData>>(new Map())

  const locationStore = useLocationStore()
  const dateTimeStore = useSubscriptionDateTimeStore()
  const { city } = storeToRefs(locationStore)
  const { startDateTime, durationMonths } = storeToRefs(dateTimeStore)

  watchEffect(() => {
    if (!city.value || !durationMonths.value)
      return

    // TODO: use dedicated subscription endpoint when available
    prebookingApi.getLocationVehicles({
      locationId: city.value.locationId,
      locationVehiclesRequest: { startDate: startDateTime.value },
    })
      .then((vehicleCategories: VehicleCategoryData[]) => {
        buildSeriesToCategory.clear()
        buildSeriesToData.clear()
        vehicleCategories.forEach((conf) => {
          conf.buildSeries.forEach(bs => buildSeriesToCategory.set(bs, conf.vehicleCategory))
          conf.buildSeries.forEach(bs => buildSeriesToData.set(bs, conf))
        })
      })
      .catch((error) => {
        Sentry.captureException(error)
      })
  })

  const allBuildSeries = computed(() => Array.from(buildSeriesToCategory.keys()))

  function getCategory(buildSeries: string): VehicleCategoryDataVehicleCategoryEnum | undefined {
    return buildSeriesToCategory.get(buildSeries)
  }

  function getVehicleData(buildSeries: string): VehicleCategoryData | undefined {
    return buildSeriesToData.get(buildSeries)
  }

  return { allBuildSeries, getCategory, getVehicleData }
})
